import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className='service'>
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Responisive Website Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Responisive App Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>2-3 months free modification</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Source File</p>
            </li>
          </ul>
        </article>

        {/* ========= END OF UI/UX DESIGN ========== */}

        <article className='service'>
          <div className="service__head">
            <h3>Graphics Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Logo Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Business Card</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Brand Identity</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Banner Design or Flyer</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Source file</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Every kind of file format</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>2-3 Month Free Modification</p>
            </li>
          </ul>
        </article>
        {/* ======== End of Graphics Design ========= */}

        <article className='service'>
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Responsive Website Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>WordPress</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Complete Instruction to customize</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Website Development</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>HTML, CSS, JS and ReactJS</p>
            </li>
          </ul>
        </article>
        {/* =========== END OF WEB DEVELOPMENT ========== */}

      </div>
    </section>
  )
}

export default Services